
import { defineComponent, ref, computed } from "vue";
import Icon from "@moonlight/vue3/components/Icon.vue";

export default defineComponent({
  components: {
    Icon,
  },
  props: {
    name: {
      type: String,
      default: "query",
    },
    modelValue: {
      type: String,
      default: "",
      required: true,
    },
    variant: {
      type: String,
      validator: (val: string) => ["light", "dark"].includes(val),
      required: false,
    },
  },
  setup(props) {
    const inputElement = ref();
    const variantClass = computed(() => ({
      "c-search--light": props.variant == "light",
      "c-search--dark": props.variant == "dark",
    }));
    return {
      inputElement,
      variantClass,
      focus: () => inputElement.value.focus(),
    };
  },
});
